/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_home_card_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimize your fantasy team with AI-powered simulations and budget-aware recommendations.`)
};

const es_f1_home_card_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimiza tu equipo de fantasía con simulaciones impulsadas por IA y recomendaciones ajustadas al presupuesto.`)
};

const de_f1_home_card_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimiere dein Fantasy-Team mit KI-gestützten Simulationen und budgetbewussten Empfehlungen.`)
};

const nl_f1_home_card_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimaliseer je fantasy-team met AI-gestuurde simulaties en budgetbewuste aanbevelingen.`)
};

const fr_f1_home_card_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimisez votre équipe fantasy avec des simulations IA et des recommandations adaptées au budget.`)
};

const it_f1_home_card_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottimizza il tuo team fantasy con simulazioni AI e consigli adatti al budget.`)
};

const pt_br2_f1_home_card_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otimize sua equipe fantasy com simulações de IA e recomendações conscientes do orçamento.`)
};

const pt_f1_home_card_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otimize a sua equipa fantasy com simulações de IA e recomendações ajustadas ao orçamento.`)
};

const ja_f1_home_card_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIシミュレーションと予算に合わせた推薦でファンタジーチームを最適化。`)
};

const zh_f1_home_card_apex_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通过AI模拟和预算感知推荐优化您的梦幻车队。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_home_card_apex_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_home_card_apex_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_home_card_apex_desc", locale)
	if (locale === "en") return en_f1_home_card_apex_desc(inputs)
	if (locale === "es") return es_f1_home_card_apex_desc(inputs)
	if (locale === "de") return de_f1_home_card_apex_desc(inputs)
	if (locale === "nl") return nl_f1_home_card_apex_desc(inputs)
	if (locale === "fr") return fr_f1_home_card_apex_desc(inputs)
	if (locale === "it") return it_f1_home_card_apex_desc(inputs)
	if (locale === "pt-BR") return pt_br2_f1_home_card_apex_desc(inputs)
	if (locale === "pt") return pt_f1_home_card_apex_desc(inputs)
	if (locale === "ja") return ja_f1_home_card_apex_desc(inputs)
	return zh_f1_home_card_apex_desc(inputs)
};